module.exports = __webpack_public_path__ + "img/light_bg.5c37fdee.png";